import { FC } from 'react';
import { useTranslation } from 'next-i18next';

import { Image } from '@phoenix/team-m/dashboard/frontend/shared/components/image';

import { containerQueries } from '@phoenix/design-system/frontend/ui/breakpoints/breakpoints';

interface BatteryDetailsProps {
  imageSrc?: string;
  productName: string;
}

export const BatteryDetails: FC<BatteryDetailsProps> = ({ imageSrc, productName }) => {
  const { t } = useTranslation('shared');

  return (
    <div className="flex items-center tablet:justify-between">
      <div className="relative aspect-[16/9] w-[6.5rem]">
        <Image
          src={imageSrc || ''}
          fill
          className="object-contain"
          alt={productName}
          sizes={`(max-width: ${containerQueries.tablet}) 80vw, (max-width: ${containerQueries.desktop}) 50vw, 20vw`}
        />
      </div>
      <div className="flex flex-col gap-y-2">
        <span className="stihl-text-body-sm-reg">{t('shared_productCategory_accessories_battery_label')}</span>
        <span className="w-32 text-ellipsis stihl-text-body-sm-bold tablet:overflow-hidden tablet:stihl-text-body-default-bold">
          {productName}
        </span>
      </div>
    </div>
  );
};
